import './polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "@fortawesome/fontawesome-free/css/all.min.css";
import ReactGA from 'react-ga';
import { Auth0Provider } from "@auth0/auth0-react";
import config from 'devextreme/core/config';



const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENTID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

export const initGA = () => {
    ReactGA.initialize("UA-75182977-7"); // put your tracking id here
};
export const GApageView = (page) => {
    ReactGA.pageview(page);
};
export const GAmodalView = (modal) => {
    ReactGA.modalview(modal);
};
export const GAevent = (categoryName, eventName) => {
    ReactGA.event({
        category: categoryName,  // Required
        action: eventName,       // Required
        label: 'Uploader',
        value: 10,
        nonInteraction: false
    });
}
export const GAtiming = (categoryName, variableName, valueNum) => {
    ReactGA.timing({
        category: categoryName,
        variable: variableName,
        value: valueNum
    });
};
export const GAexception = (detail) => {
    ReactGA.exception({ description: detail });
};

config({
    licenseKey: process.env.REACT_APP_DEVEXTREME_LICENSE_KEY
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
            redirect_uri: window.location.origin,
            audience: audience,
            //scope: scope
        }}
    >
        <App />
    </Auth0Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

